// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tagIpAvailable{
    width: 65%;
    height: 60%;
    background-color: var(--green-low);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    
}

.full-excels-buttons-portafolio{
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    width: 100% ;
}

.img-full-dwnld-portafolio{
    
    width: 20%;
  }
.img-full-dwnld-portafolio:hover{
    width: 22%;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/config-components/Hosts/styles/hostStyles.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,WAAW;IACX,kCAAkC;IAClC,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;;AAEtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;;AAEA;;IAEI,UAAU;EACZ;AACF;IACI,UAAU;IACV,eAAe;AACnB","sourcesContent":[".tagIpAvailable{\r\n    width: 65%;\r\n    height: 60%;\r\n    background-color: var(--green-low);\r\n    border-radius: 5px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    text-align: center;\r\n    \r\n}\r\n\r\n.full-excels-buttons-portafolio{\r\n    position: relative;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100%;\r\n    width: 100% ;\r\n}\r\n\r\n.img-full-dwnld-portafolio{\r\n    \r\n    width: 20%;\r\n  }\r\n.img-full-dwnld-portafolio:hover{\r\n    width: 22%;\r\n    cursor: pointer;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
